import { apiClient, assertOk } from "@/api/generated/client.ts"
import { dataPointSchema } from "@/types/dataPointSchemas.ts"
import type { DataPoint } from "@/types/dataPointTypes.ts"

export const getDataPoint = async (id: number): Promise<DataPoint> => {
  const { data, error, response } = await apiClient.GET("/api/DataPoints/{id}", {
    params: { path: { id } },
  })
  return dataPointSchema.parse(assertOk(response, error, data))
}
